<template>
	<v-card flat class="ma-0">
		<v-form ref="form" @submit.prevent>
			<h6 class="text-body-1 font-weight-bold mt-2">絞り込み</h6>
			<v-row no-gutters justify="center">
				<v-col cols="12" sm="6" lg="4" class="mt-4 px-1">
					<v-select
						label="対象"
						v-model="targetType"
						:items="targetTypes"
						item-text="name"
						item-value="id"
						dense
						outlined
					/>
				</v-col>
				<template v-if="targetType == 'matter'">
					<v-col cols="12" sm="6" lg="4" class="mt-4 px-1">
						<v-text-field label="見積番号" v-model="q.quotation_number_cont" dense outlined />
					</v-col>
					<v-col cols="12" sm="6" lg="4" class="mt-4 px-1">
						<v-text-field label="受注番号" v-model="q.order_number_cont" dense outlined />
					</v-col>
				</template>
				<template v-else-if="targetType == 'matter_product'">
					<v-col cols="12" sm="6" lg="4" class="mt-4 px-1">
						<v-text-field label="製造番号" v-model="q.product_number_cont" dense outlined />
					</v-col>
					<v-col cols="12" sm="6" lg="4" class="mt-4 px-1">
						<v-text-field label="品名" v-model="q.quotation_number_cont" dense outlined />
					</v-col>
				</template>
				<v-col cols="12" sm="6" lg="4" class="mt-4 px-1">
					<v-row no-gutters>
						<v-col cols="6" class="pr-1">
							<v-btn width="100%" @click="search" color="secondary">
								<v-icon class="mr-2">mdi-magnify</v-icon>
								検索</v-btn
							>
						</v-col>
						<v-col cols="6" class="pl-1">
							<v-btn width="100%" @click="resetForm" outlined color="secondary">
								<v-icon class="mr-2">mdi-autorenew</v-icon>
								クリア</v-btn
							>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-form>
	</v-card>
</template>

<script>
export default {
	props: {
		text: {
			type: Boolean,
			default: false,
		},
		query: {
			type: Object,
			required: true,
		},
		target_type: {
			type: String,
		},
	},
	data() {
		return {
			dialog: false,
			targetType: null,
			q: {},
			targetTypes: [
				{ id: "matter", name: "案件" },
				{ id: "matter_product", name: "製品" },
			],
		}
	},
	mounted() {
		this.q = this.query
		this.targetType = this.target_type
	},
	methods: {
		search() {
			this.$emit("search-targets", this.q, this.targetType)
			this.dialog = false
		},
		resetForm() {
			this.$refs.form.reset()
		},
	},
	watch: {
		query: {
			handler(val) {
				this.q = val
			},
			deep: true,
		},
		target_type: {
			handler(val) {
				this.targetType = val
			},
			deep: true,
		},
	},
}
</script>